/**
 * @desc sku报价启用
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.Response;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/supplierQuotationEnable/${id}`, {
      method: "POST",

      ...options,
    }),
  );
}
